import { render } from "./pfdetail.vue?vue&type=template&id=a9c667ba&scoped=true"
import script from "./pfdetail.vue?vue&type=script&lang=js"
export * from "./pfdetail.vue?vue&type=script&lang=js"

import "./pfdetail.vue?vue&type=style&index=0&id=a9c667ba&lang=scss&scoped=true"
import "./pfdetail.vue?vue&type=style&index=1&id=a9c667ba&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c667ba"]])

export default __exports__